module.exports = __webpack_public_path__ + "img/24.6edbfdd6.jpg";